import normalizeEntity from 'normalized-redux/entity-normalizer';

const normalizedGroups = normalizeEntity<Oneflow.Group, 'group', string[]>({ entity: 'group' });

export default normalizedGroups;
